export const CONFIRM_FORGOT_PASSWORD_TEXTS = {
    TITLE: 'Create New Password',
    SUBTITLE: 'Make sure that your new Password is different than previous ones.',
    BUTTON: 'Reset Password',
    CODE_MISMATCH_OR_EXPIRED_CODE_EXCEPTION: 'This link is expired or invalid. Click here to retry the process and check your email',
};

export const MIN_PASSWORD_LENGTH = 8;

export const CONFIRM_FORGOT_PASSWORD_TEST_IDS = {
    PAGE: 'CONFIRM_FORGOT_PASSWORD_PAGE',
    INPUT_PASSWORD: 'CONFIRM_FORGOT_PASSWORD_INPUT_PASSWORD',
    INPUT_CONFIRM_PASSWORD: 'CONFIRM_FORGOT_PASSWORD_INPUT_CONFIRM_PASSWORD',
    SUBMIT_BUTTON: 'CONFIRM_FORGOT_PASSWORD_SUBMIT_BUTTON',
    PASSWORD_ERROR_MESSAGE: 'CONFIRM_FORGOT_PASSWORD_PASSWORD_ERROR_MESSAGE',
    CONFIRM_PASSWORD_ERROR_MESSAGE: 'CONFIRM_FORGOT_PASSWORD_CONFIRM_PASSWORD_ERROR_MESSAGE',
};

export const CONFIRM_FORGOT_PASSWORD_DATA_AUTO_TEST_IDS = {
    PAGE: 'CONFIRM_FORGOT_PASSWORD_PAGE',
    INPUT_PASSWORD: 'CONFIRM_FORGOT_PASSWORD_INPUT_PASSWORD',
    INPUT_CONFIRM_PASSWORD: 'CONFIRM_FORGOT_PASSWORD_INPUT_CONFIRM_PASSWORD',
    SUBMIT_BUTTON: 'CONFIRM_FORGOT_PASSWORD_SUBMIT_BUTTON',
    PASSWORD_ERROR_MESSAGE: 'CONFIRM_FORGOT_PASSWORD_PASSWORD_ERROR_MESSAGE',
    CONFIRM_PASSWORD_ERRO_MESSAGE: 'CONFIRM_FORGOT_PASSWORD_CONFIRM_PASSWORD_ERROR_MESSAGE',
};
